<template>
  <Layout style="height: 100%" class="main" v-if="showRouter">
    <Sider hide-trigger collapsible :width="256" :collapsed-width="64" v-model="collapsed" class="left-sider" :style="{overflow: 'hidden'}">
      <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed" @on-select="turnToPage" :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div v-show="!collapsed" class="logo-con">
          <img :src="lang === 'en' ? maxEnLogo : maxLogo" key="max-logo" />
        </div>
        <div v-show="collapsed" class="logo-con-min">
          <img :src="minLogo" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
          <user :user-avator="userAvator"/>
          <switchSys/>
          <Language />

          <MessageCenter class="message-center-trigger" />
          <fullscreen v-model="isFullscreen" class="header-action-fullscreen"/>
          <!-- 三维看板按钮 -->
          <div v-if="showThreeDDashboard" class="three-d-dashboard-btn" @click="openThreeDDashboard">
            <Icon type="ios-cube" :size="48" style="color: #2d8cf0; margin-right: 6px;"></Icon>
            <span class="btn-text">{{ langMap.threeDDashboard[lang] }}</span>
          </div>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
          </div>
          <Content class="content-wrapper">
            <keep-alive :include="cacheList" v-if="mainInitialized">
              <router-view/>
            </keep-alive>
            <div v-else class="loading-placeholder">
              <!-- 可以添加加载提示 -->
              <Spin size="large"></Spin>
            </div>
            <ABackTop :height="100" :bottom="80" :right="50" container=".content-wrapper"></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>

    <!-- 紧急通知容器 -->
    <div id="emergency-notification-container"></div>
  </Layout>
</template>
<script>
import api from "@/api"
import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import ABackTop from './components/a-back-top'
import Fullscreen from './components/fullscreen'
import MessageCenter from './components/language'
import ErrorStore from './components/error-store'
import ErrorNotification from '@/view/monitor/dashboard/module/error/ErrorNotification.vue'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { getNewTagList, getNextRoute, routeEqual } from '@/libs/util'
import routers from '@/router/routers'
import minLogo from '@/assets/images/logo-min.png'
import maxLogo from '@/assets/images/logo.png'
import maxEnLogo from '@/assets/images/logo-en.png'
import userFace from '@/assets/images/user-face.jpg'
import switchSys from '@/components/switchSys/index.vue';
import Language from '@/components/Language/index.vue';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { connectWithUrl }  from '@/utils/websocket'
import Vue from 'vue'
import { buildNotificationContent, buildCapacityAlertDescription } from '@/view/monitor/dashboard/module/error/notificationContent'
import {
  beginAlertNotification,
  closeAlertNotification,
  createAlertNotificationState,
  muteAlertNotification
} from '@/view/monitor/dashboard/module/error/alertNotificationControl'

import './main.less'

export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    MessageCenter,
    TagsNav,
    Language,
    Fullscreen,
    ErrorStore,
    User,
    ABackTop,
    switchSys
  },
  data () {
    return {
      langMap:langMap,
      collapsed: false,
      minLogo,
      maxLogo,
      maxEnLogo,
      isFullscreen: false,

      //是否显示页面
      showRouter:false,
      // 添加主组件初始化完成标识
      mainInitialized: false,
      warningNoticeId:'',
      sentimentId: '',
      warningMuteUntil: localStorage.getItem('warningMuteUntil') || 0,  // 从localStorage读取
      sentimentMuteUntil: localStorage.getItem('sentimentMuteUntil') || 0, // 从localStorage读取

      // 三维看板相关
      showThreeDDashboard: false, // 是否显示三维看板按钮
      threeDDashboardUrl: '', // 三维看板URL
      
      // 事件监听器处理器
      muteEventHandler: null,
      customEventHandler: null,
      sentimentEventHandler: null,
      
      // 去重：记录最后一次通知的时间戳
      lastWarningTimestamp: 0,
      lastSentimentTimestamp: 0,
      lastCapacityAlertKey: '',
      lastCapacityAlertTimestamp: 0,
      ...createAlertNotificationState()
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    ...mapGetters([
      'errorCount'
    ]),
    tagNavList () {
      return this.$store.state.app.tagNavList
    },
    tagRouter () {
      return this.$store.state.app.tagRouter
    },
    userAvator () {
      return userFace;
    },
    cacheList () {
      return ['ParentView', ...this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []]
    },
    menuList () {
      return this.$store.state.app.sysMenulist
    },
    local () {
      return this.$store.state.app.local
    },
    hasReadErrorPage () {
      return this.$store.state.app.hasReadErrorPage
    }
  },
  watch: {
    '$route' (newRoute) {
      const { name, query, params, meta } = newRoute
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      })
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      this.$refs.sideMenu.updateOpenName(newRoute.name)
    }
  },


  created(){
    this.getUserInfo();

    // 检查是否显示三维看板按钮
    const thdime = sessionStorage.getItem('thdime');
    if (thdime === '1') {
      this.showThreeDDashboard = true;
      // 获取三维看板配置
      this.getThreeDDashboardConfig();
    }
  },


  mounted () {
    // 移除旧的监听器（如果存在）
    if (this.customEventHandler) {
      document.body.removeEventListener("custom-event", this.customEventHandler);
    }
    if (this.sentimentEventHandler) {
      document.body.removeEventListener("sentiment-custom-event", this.sentimentEventHandler);
    }
    if (this.muteEventHandler) {
      document.body.removeEventListener("mute-event", this.muteEventHandler);
    }
    
    // 添加 custom-event 监听器
    this.customEventHandler = (event) => {
       // console.log('[>>>>>>]',event.detail);
      switch (event.detail.type) {
        case 1: 
          // 检查标签栏中是否已有网枪记录页面,有则先关闭
          this.navigateToPageWithoutDuplicateTag({
            path:'/data/gunRecord',
            name: 'gunRecord',
            query: {
              timestamp: event.detail.data.data.timestamp,
              robotId: event.detail.data.robotId
            }
          });
          break;
        case 2: this.gunOperate(false, event.detail.data); break;
        case 3: this.gunOperate(true, event.detail.data); break;
        default:
      }
      this.$Notice.close(event.detail.data.code + '_gun')
    };
    document.body.addEventListener("custom-event", this.customEventHandler);
    
    // 添加 sentiment-custom-event 监听器
    this.sentimentEventHandler = (event) => {
      console.log('[>>>>>>]',event.detail);
      switch (event.detail.type) {
        case 1: 
          // 检查标签栏中是否已有告警处理页面,有则先关闭
          this.navigateToPageWithoutDuplicateTag({
            path:'/data/alarmHandling',
            name: 'alarmHandling',
            query: {
              timestamp: event.detail.data.data.timestamp,
              robotId: event.detail.data.robotId
            }
          });
          break;
        case 2: this.switchVideo(event.detail.data); break;
        case 3: this.sentimentOperate(event.detail.data); break;
        default:
      }
      this.$Notice.close(event.detail.data.code + '_sentiment')
    };
    document.body.addEventListener("sentiment-custom-event", this.sentimentEventHandler);
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.setHomeRoute(routers)
    this.addTag({
      route: this.$store.state.app.homeRoute
    })
    this.setBreadCrumb(this.$route)
    // 设置初始语言
    this.setLocal(this.$i18n.locale)
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      })
    }

    // 添加时间单位切换函数到window对象
    window.setTimeUnit = (id, element, multiplier) => {
      // 移除其他单位的active类
      const units = element.parentElement.getElementsByClassName('time-unit');
      Array.from(units).forEach(unit => unit.classList.remove('active'));
      // 添加active类到当前单位
      element.classList.add('active');
      // 保存乘数到input的data属性
      document.getElementById(`muteTime_${id}`).dataset.multiplier = multiplier;
    };

    // 添加静默事件监听器
    this.muteEventHandler = (event) => {
      const { type, id, value } = event.detail;
      if (!value) {
        this.$Message.warning('请选择或输入时间');
        return;
      }
      this.setMuteTime(type, value);
    };
    document.body.addEventListener("mute-event", this.muteEventHandler);

    // 添加 select change 事件监听
    document.body.addEventListener("change", (event) => {
      if (event.target.classList.contains('time-select')) {
        const customInput = event.target.nextElementSibling;
        if (customInput && customInput.classList.contains('custom-time-input')) {
          customInput.style.display = event.target.value === 'custom' ? 'inline-block' : 'none';
        }
      }
    });

    // 添加全局引用以便在内联JavaScript中使用
    window.app = this;
    this.ratioW()
  },

  beforeDestroy() {
    delete window.app;

    // 关闭 WebSocket 连接
    if (window._globalWebsockets && window._globalWebsockets.length > 0) {
      window._globalWebsockets.forEach(ws => {
        if (ws && ws.readyState === WebSocket.OPEN) {
          ws.close();
          console.log('WebSocket 连接已关闭');
        }
      });
      // 清空全局 WebSocket 数组
      window._globalWebsockets = [];
    }

    // 关闭所有 Notice 弹窗
    this.$Notice.destroy();

    // 移除所有事件监听器
    if (this.customEventHandler) {
      document.body.removeEventListener("custom-event", this.customEventHandler);
    }
    if (this.sentimentEventHandler) {
      document.body.removeEventListener("sentiment-custom-event", this.sentimentEventHandler);
    }
    if (this.muteEventHandler) {
      document.body.removeEventListener("mute-event", this.muteEventHandler);
    }
  },

  methods: {
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setLocal',
      'setHomeRoute'
    ]),
    turnToPage (route) {
      let { name, params, query } = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name,
        params,
        query
      })
    },
    handleCollapsedChange (state) {
      this.collapsed = state
    },
    handleCloseTag (res, type, route) {
      if (type === 'all') {
        this.turnToPage(this.$config.homeName)
      } else if (routeEqual(this.$route, route)) {
        if (type !== 'others') {
          const nextRoute = getNextRoute(this.tagNavList, route)
          this.$router.push(nextRoute)
        }
      }
      this.setTagNavList(res)
    },
    handleClick (item) {
      this.turnToPage(item)
    },

    //更新后台允许访问菜单数组
    getUserInfo(){
      this.showRouter=false;
      this.$Spin.show();
      api.getData('system-server/user/get/home/date',this).then((res)=>{
        this.$Spin.hide();
        if(res.state==0){
          this.showRouter=false;
          //跳转错误页面
          this.$router.push({
              name: 'error_500'
          });
        }else{
          if(!res.data.menu.length){
            // 没有菜单数据，显示提示并跳转到登录页
            this.$Modal.info({
              title: langMap.noMenuPermission[this.lang],
              content: langMap.noMenuPermissionMessage[this.lang],
              okText: langMap.confirm[this.lang],
              onOk: () => {
                // 清除用户信息并跳转到登录页
                this.$store.commit('logOut');
                this.$router.push({
                  name: 'login'
                });
              }
            });
            return;
          }
          // 用户信息不完整（无 loginUser 或缺少 userId）视为会话数据异常，
          // 不渲染业务页，避免后续页面读取到 undefined 的 userId
          if(!res.data.loginUser || !res.data.loginUser.userId){
            this.showRouter=false;
            this.$router.push({
              name: 'error_500'
            });
            return;
          }
          //保存全局动态菜单数据
          this.$store.commit('updateMenulist',res.data.menu);
          this.$store.commit('muChnageUserInfo', res.data.loginUser);
          this.$store.commit('setBreadCrumb', this.$route);
          this.showRouter=true;
          //console.log(res.data.loginUser)
          this.socketInit('msgSocketUrl', res.data.loginUser.userId, this.callback, this);

          this.loadComplete()
          // this.warning({data:{msg:'请求打开网枪',img:''}});
        }
      })
    },
    socketInit(key, userId, callback, _this){
      connectWithUrl('/ssf', key, userId, callback);
    },
    loadComplete() {
      this.$nextTick(() => {
        // 通知全局主组件已初始化完成
        this.mainInitialized = true;
      });
    },
    callback(data){
      const ret = JSON.parse(data);
      switch (ret.type) {
        case '1':
          this.$Notice.info({
            title: langMap.systemMessage[this.lang],
            desc: ret.data
          });
          break;
          case 'gun:': this.warning(ret); break;
          case 'sentiment:': this.sentiment(ret); break;
          case 'emergency_info':
          case 'alert_info': this.emergencyNotice(ret); break;
          case 'capacity_alert': this.capacityAlert(ret); break;
          default:
      }
    },
    createNoticeHtml(data, type) {
      const id = type === 'warning' ?
        data.data.code + '_gun' :
        data.data.code + '_sentiment';

      const customEvent = type === 'warning' ?
        'custom-event' :
        'sentiment-custom-event';

      return `
        <div class="notice-container">
          <h2 class="notice-title">${this.langMap.targetDetected[this.lang]}</h2>
          <img class="notice-img" src="${data.data.img}"/>
          <div class="notice-content">
            <div class="mute-settings">
              <div class="time-input-wrapper">
                <div class="error-tip" id="errorTip_${id}"></div>
                <span class="mute-label">${this.langMap.ignore[this.lang]}:</span>
                <select class="time-select" id="muteTime_${id}">
                  <option value="30">30${this.langMap.second[this.lang]}</option>
                  <option value="60">60${this.langMap.second[this.lang]}</option>
                  <option value="90">90${this.langMap.second[this.lang]}</option>
                  <option value="120">120${this.langMap.second[this.lang]}</option>
                  <option value="custom">${this.langMap.customize[this.lang]}</option>
                </select>
                <input type="number" class="custom-time-input" id="customTime_${id}" style="display:none" min="1" placeholder="${this.langMap.second[this.lang]}"/>
                <button class="mute-confirm" onclick='javascript:
                  try {
                    var errorTip = document.getElementById("errorTip_${id}");
                    var select = document.getElementById("muteTime_${id}");
                    var customInput = document.getElementById("customTime_${id}");
                    errorTip.textContent = ""; // 清除之前的错误提示

                    if (!select) {
                      errorTip.textContent = "系统错误：找不到选择框元素";
                      return;
                    }
                    var value = select.value;
                    if (value === "custom") {
                      value = customInput.value;
                      if (!value) {
                        errorTip.textContent = "${this.langMap.PleaseInputTime[this.lang]}";
                        customInput.focus();
                        return;
                      }
                      if (value <= 0) {
                        errorTip.textContent = "${this.langMap.PleaseInputMax[this.lang]}";
                        customInput.focus();
                        return;
                      }
                    }
                    document.body.dispatchEvent(new CustomEvent("mute-event", {
                      detail: {
                        type: "${type}",
                        id: "${id}",
                        value: value
                      }
                    }));
                  } catch(e) {
                    errorTip.textContent = e.message;
                  }
                '>${this.langMap.confirm[this.lang]}</button>
              </div>
            </div>
            <div class="action-buttons">
              <Button class="btn primary" onclick='javascript:var k = new CustomEvent("${customEvent}",{detail:${JSON.stringify({type:1,data:data})}});document.body.dispatchEvent(k);'>${this.langMap.details[this.lang]}</Button>
              <Button class="btn danger" onclick='javascript:var k = new CustomEvent("${customEvent}",{detail:${JSON.stringify({type:3,data:data})}});document.body.dispatchEvent(k);'>${type === 'warning' ? this.langMap.allow[this.lang] : this.langMap.noDeal[this.lang]}</Button>
            </div>
          </div>
        </div>`;
    },

    showNotice(data, type) {
      const currentTime = Date.now();
      const storageKey = type === 'warning' ? 'warningMuteUntil' : 'sentimentMuteUntil';
      const savedMuteUntil = parseInt(localStorage.getItem(storageKey)) || 0;

      // 检查是否在静默期
      if (currentTime < savedMuteUntil) {
        return;
      }

      const id = type === 'warning' ?
        data.data.code + '_gun' :
        data.data.code + '_sentiment';
      
      // 去重：500ms 内不重复显示同一条通知
      const lastTimestamp = type === 'warning' ? this.lastWarningTimestamp : this.lastSentimentTimestamp;
      const messageId = data.data.messageId || data.data.code;
      if (currentTime - lastTimestamp < 500 && (type === 'warning' ? this.warningNoticeId : this.sentimentId) === id) {
        return;
      }
      
      if (type === 'warning') {
        this.lastWarningTimestamp = currentTime;
      } else {
        this.lastSentimentTimestamp = currentTime;
      }

      // 关闭之前的通知
      this.$Notice.close(type === 'warning' ? this.warningNoticeId : this.sentimentId);

      // 保存当前通知ID
      if (type === 'warning') {
        this.warningNoticeId = id;
      } else {
        this.sentimentId = id;
      }

      // 显示通知
      this.$Notice.warning({
        key: id,
        name: id,
        title: this.langMap.robot[this.lang] + ':' + data.data.code,
        desc: this.createNoticeHtml(data, type),
        duration: 0
      });
    },

    warning(data) {
      this.showNotice(data, 'warning');
    },

    sentiment(data) {
      this.showNotice(data, 'sentiment');
    },

    showErrorNotificationInstance({
      title,
      description,
      robotId,
      ignoreDefaultSeconds,
      type = 'emergency',
      duration = 10000,
      showIgnore = true,
      timestamp = '',
      subtitle = '',
      onClose,
      onIgnore
    }) {
      const container = document.createElement('div')
      document.body.appendChild(container)

      const NotificationConstructor = Vue.extend(ErrorNotification);
      const instance = new NotificationConstructor({
        parent: this,
        propsData: {
          title,
          description,
          type,
          duration,
          robotId,
          ignoreDefaultSeconds,
          showIgnore,
          timestamp,
          subtitle
        }
      })

      const destroyInstance = () => {
        instance.$destroy()
        if (container.parentNode) {
          container.parentNode.removeChild(container)
        }
      }

      instance.$on('close', () => {
        if (onClose) onClose()
        destroyInstance()
      })

      instance.$on('ignore', (...args) => {
        if (onIgnore) onIgnore(...args)
        destroyInstance()
      })

      instance.$mount()
      container.appendChild(instance.$el)
    },

    emergencyNotice(data) {
      const sourceType = data.type === 'alert_info' ? 'alert_info' : 'emergency_info'

      if (sourceType === 'alert_info' && !beginAlertNotification(this)) return

      const notice = buildNotificationContent(
        sourceType,
        data,
        key => this.langMap[key] ? this.langMap[key][this.lang] : key
      )

      if (sourceType === 'emergency_info') {
        this.showErrorNotificationInstance(notice)
        return
      }

      this.showErrorNotificationInstance({
        ...notice,
        ignoreDefaultSeconds: Math.max(1, Math.floor(this.alertInfoIgnoreDuration / 1000)),
        onClose: () => {
          closeAlertNotification(this)
        },
        onIgnore: (_, seconds) => {
          muteAlertNotification(this, seconds)
        }
      })
    },

    // 服务端标题形如「2026-08-12 12:00:00 磁盘容量告警 - 清理后使用率仍达92.4%」
    // 拆成时间 / 标题 / 补充说明三段，避免整句挤在标题里
    parseAlertTitle(rawTitle) {
      const text = String(rawTitle || '').trim();
      const timeMatch = text.match(/^(\d{4}-\d{2}-\d{2}(?:\s+\d{2}:\d{2}(?::\d{2})?)?)\s*/);
      const timestamp = timeMatch ? timeMatch[1] : '';
      const rest = timeMatch ? text.slice(timeMatch[0].length).trim() : text;
      const separatorIndex = rest.indexOf(' - ');

      if (separatorIndex === -1) return { timestamp, title: rest, subtitle: '' };
      return {
        timestamp,
        title: rest.slice(0, separatorIndex).trim(),
        subtitle: rest.slice(separatorIndex + 3).trim()
      };
    },

    // 磁盘容量告警：清理后仍超阈值时服务端主动推送，需人工介入
    capacityAlert(message) {
      const data = (message && message.data) || {};
      const isEnglish = this.lang === 'en';
      const title = (isEnglish ? data.titleEn : data.titleZh) ||
        data.titleZh || data.titleEn || langMap.notifyCapacityAlert[this.lang];
      const summary = (isEnglish ? data.summaryEn : data.summaryZh) ||
        data.summaryZh || data.summaryEn || '';

      // 同一任务的重复推送在 1 秒内只提示一次
      const key = data.taskId || title;
      const now = Date.now();
      if (key === this.lastCapacityAlertKey && now - this.lastCapacityAlertTimestamp < 1000) return;
      this.lastCapacityAlertKey = key;
      this.lastCapacityAlertTimestamp = now;

      const description = buildCapacityAlertDescription(
        summary,
        data.content,
        key => (this.langMap[key] ? this.langMap[key][this.lang] : key)
      );

      const heading = this.parseAlertTitle(title);

      // 复用页面统一的告警弹窗；需人工介入，不自动关闭，也不提供“忽略 N 秒”
      this.showErrorNotificationInstance({
        title: heading.title || title,
        timestamp: heading.timestamp,
        subtitle: heading.subtitle,
        description: description,
        robotId: data.taskId || '',
        type: 'warning',
        duration: 0,
        showIgnore: false
      });

      // 服务端已落库一条通知，同步刷新导航栏铃铛未读数
      document.body.dispatchEvent(new CustomEvent('notification-refresh'));
    },

    gunOperate(type, data){
      this.$Modal.confirm({
        title: langMap.systemTip[this.lang],
        content: type ? langMap.confirmOpenNetGun[this.lang] : langMap.confirmRejectOperation[this.lang],
        onOk: () => {
          this.$Spin.show();
          let d = {
            timestamp: data.data.timestamp,
            flag: type
          };
          const code = data ? data.data.code : undefined
          api
            .postData("notice-server/cmd/gun", { robotId: data.robotId,code, data: d }, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.success[this.lang],
                  desc: res.message
                });
              }
              this.$Spin.hide();
            });
        }
      });
    },
    switchVideo(data) {
      let routedata = this.$router.resolve({
        path: "/lol",
        query: {
          id: data.robotId,
          timestamp: data.data.timestamp,
        }
      });
      window.open(routedata.href, "_blank");
    },
    sentimentOperate(data){
      this.$Modal.confirm({
        title: langMap.systemTip[this.lang],
        content: langMap.confirmIgnoreAlarm[this.lang],
        onOk: () => {
          this.$Spin.show();
          let d = {
            timestamp: data.data.timestamp,
            ret: 4
          };
          const code = data ? data.data.code : undefined
          api
            .postData("notice-server/cmd/sentiment", { robotId: data.robotId,code, data: d }, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tips[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.success[this.lang],
                  desc: res.message
                });
              }
              this.$Spin.hide();
            });
        }
      });
    },
    // 设置静默时间
    setMuteTime(type, seconds) {
      const value = parseInt(seconds);
      if (!value || value <= 0) {
        this.$Message.warning({
          content: this.langMap.enterValidTime[this.lang],
          duration: 3
        });
        return;
      }

      const muteUntil = Date.now() + value * 1000;

      if (type === 'warning') {
        this.warningMuteUntil = muteUntil;
        localStorage.setItem('warningMuteUntil', muteUntil);
        this.$Notice.close(this.warningNoticeId);
      } else {
        this.sentimentMuteUntil = muteUntil;
        localStorage.setItem('sentimentMuteUntil', muteUntil);
        this.$Notice.close(this.sentimentId);
      }

      const reminderMsg = this.langMap.reminderNotGiveAgain[this.lang].replace('{seconds}', value);
      this.$Message.success({
        content: reminderMsg,
        duration: 3
      });
    },
    //自适应屏幕
    ratioW(text) {
      var targetWidth = text || 1600;
      var style = document.createElement("style");
      style.innerHTML = `
         body {
           width: 100%;
           height: 100%;
           margin: 0;
         }
         `;
      document.head.appendChild(style);

      let adjustWindow = () => {
        let ratio = window.innerWidth / targetWidth;
        if (ratio > 1) ratio = 1;
        const defaultZoom = document.documentElement.getAttribute("defaultZoom")
        if(defaultZoom){
          ratio = parseFloat(ratio > defaultZoom ? defaultZoom : ratio)
        }
        document.documentElement.style.zoom = ratio;

        document.documentElement.setAttribute("data-ratio", ratio);
      };
      adjustWindow();
      window.addEventListener("resize", adjustWindow);
      // 使鼠标坐标一致
      let x_get = Object.getOwnPropertyDescriptor(MouseEvent.prototype, "x").get;
      let y_get = Object.getOwnPropertyDescriptor(MouseEvent.prototype, "y").get;
      Object.defineProperties(MouseEvent.prototype, {
        R: {
          get: function () {
            return parseFloat(document.documentElement.getAttribute("data-ratio"));
          },
        },
        x: {
          get: function () {
            return x_get.call(this) / this.R;
          },
        },
        y: {
          get: function () {
            return y_get.call(this) / this.R;
          },
        },
      });
    },

    // 获取三维看板配置
    getThreeDDashboardConfig() {
      api.getData("system-server/config/list?keys=3dDashboardUrl").then(r => {
        if (r.state == 0) {
          console.error(r.msg);
        } else {
          let config = r.data['3dDashboardUrl']
          if (config && config.configValue) {
            this.threeDDashboardUrl = config.configValue
          }
        }
      })
    },

    // 打开三维看板
    openThreeDDashboard() {
      if (!this.threeDDashboardUrl) {
        this.$Message.error(this.langMap.swConfigNotFound[this.lang]);
        return;
      }
      try {
        // 跳转到三维看板
        window.location.href = this.threeDDashboardUrl;
      } catch (error) {
        console.error('Error opening 3D dashboard:', error);
        this.$Message.error(this.langMap.openFailed[this.lang]);
      }
    },

    // 跳转到页面，避免重复标签
    navigateToPageWithoutDuplicateTag(routeConfig) {
      const { name, path, query } = routeConfig;
      
      // 检查标签栏中是否已存在同名路由
      const existingTag = this.tagNavList.find(item => item.name === name);
      
      if (existingTag) {
        // 如果已存在，先关闭旧标签
        const newTagList = this.tagNavList.filter(item => item.name !== name);
        this.setTagNavList(newTagList);
      }
      
      // 跳转到新路由（watch 会自动添加新标签）
      this.$router.push({ path, query });
    }
  }

}
</script>
<style>
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover{
    background: #EC5336 !important;
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title{
    background:#0f0f0f !important;
  }
  .ivu-menu-vertical,.ivu-menu-opened{
    background:#0f0f0f !important;
  }
  .ivu-menu-dark{
    background: #030202 !important;
  }
  .ivu-layout-sider{
    background: #030202 !important;
  }
  .btn{
    margin: 5px;
    padding: 5px 10px;
  }
  .mute-select-container {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .mute-select {
    width: 100px;
  }

  .mute-confirm {
    margin-left: 8px;
  }

  .notice-container {
    padding: 8px;
  }

  .notice-title {
    font-size: 17px;
    color: #ed4014;
    font-weight: bold;
  }

  .notice-img {
    border-radius: 4px;
    width: 120px;
    height: 120px;
    display: block;
  }

  .notice-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .mute-settings {
    margin-bottom: 4px;
  }

  .time-input-wrapper {
    position: relative;  /* 添加相对定位 */
    display: flex;
    align-items: center;
    gap: 6px;
    background: #f8f8f9;
    padding: 4px 6px;
    border-radius: 4px;
  }

  .error-tip {
    position: absolute;
    top: -20px;  /* 位于输入框上方 */
    left: 0;
    right: 0;
    text-align: center;
    color: #ed4014;
    font-size: 12px;
    min-height: 16px;
    padding: 0 4px;
  }

  /* 当有错误提示时，增加上边距 */
  .time-input-wrapper:has(.error-tip:not(:empty)) {
    margin-top: 20px;
  }

  .mute-label {
    color: #e46f2b;
    font-size: 13px;
    white-space: nowrap;
    font-weight: bold;
  }

  .time-select {
    height: 24px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    outline: none;
    padding: 0 4px;
    background: white;
    cursor: pointer;
    transition: all 0.3s;
    min-width: 65px;
  }

  .time-select:focus {
    border-color: #2d8cf0;
  }

  .custom-time-input {
    width: 60px;
    height: 24px;
    padding: 0 4px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    outline: none;
    transition: all 0.3s;
    text-align: center;
  }

  .custom-time-input:focus {
    border-color: #2d8cf0;
  }

  .mute-confirm {
    height: 24px;
    padding: 0 8px;
    font-size: 12px;
    color: #fff;
    background: #2d8cf0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
  }

  .action-buttons {
    display: flex;
    gap: 4px;
    margin-top: 4px;
  }

  .btn {
    flex: 1;
    padding: 3px 8px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s;
    margin: 0;
  }

  .btn.primary {
    background: #2db7f5;
  }

  .btn.warning {
    background: #ff9900;
  }

  .btn.danger {
    background: #ed4014;
  }

  .btn:hover {
    opacity: 0.85;
  }

  .message-center-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    line-height: 0;
    vertical-align: middle;
    margin: 0 6px 0 10px;
    transform: translateY(15px);
  }

  .header-action-fullscreen {
    line-height: 0;
    vertical-align: middle;
    margin: 0 0 0 6px;
  }
  /* 三维看板按钮样式 */
  .three-d-dashboard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 6px;
    padding: 8px 16px;
    height: 63px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, rgba(45, 140, 240, 0.1), rgba(45, 140, 240, 0.15));
    border: 1px solid rgba(45, 140, 240, 0.3);
    font-weight: 500;
    white-space: nowrap;
    box-shadow: 0 2px 4px rgba(45, 140, 240, 0.1);
  }

  .three-d-dashboard-btn .btn-text {
    color: #2d8cf0;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .three-d-dashboard-btn:hover {
    background: linear-gradient(135deg, rgba(45, 140, 240, 0.2), rgba(45, 140, 240, 0.25));
    border-color: rgba(45, 140, 240, 0.5);
    box-shadow: 0 4px 12px rgba(45, 140, 240, 0.25);
  }

  .three-d-dashboard-btn:hover .btn-text {
    color: #1c7cd6;
  }

  .three-d-dashboard-btn:active {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(45, 140, 240, 0.2);
  }

  /* 容量告警详情：突出磁盘使用率，其余清理结果紧凑展示 */
  .error-notification .description .capacity-alert-summary {
    margin: 0 0 12px;
    color: #cfe2f2;
    font-size: 13px;
    line-height: 1.65;
  }

  .error-notification .description .capacity-alert-gauge {
    margin-bottom: 12px;
    padding: 10px 12px;
    border: 1px solid rgba(255, 152, 0, .28);
    border-radius: 8px;
    background: rgba(255, 152, 0, .07);
  }

  .error-notification .description .capacity-alert-gauge-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .error-notification .description .capacity-alert-gauge-head span {
    color: #b7cee0;
    font-size: 12px;
  }

  .error-notification .description .capacity-alert-gauge-head strong {
    font-size: 20px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  .error-notification .description .capacity-alert-track {
    height: 8px;
    overflow: hidden;
    border-radius: 4px;
    background: rgba(255, 255, 255, .1);
  }

  .error-notification .description .capacity-alert-track i {
    display: block;
    height: 100%;
    border-radius: 4px;
  }

  .error-notification .description .capacity-alert-gauge-head strong.is-danger { color: #ff8a84; }
  .error-notification .description .capacity-alert-gauge-head strong.is-warning { color: #ffb454; }
  .error-notification .description .capacity-alert-gauge-head strong.is-normal { color: #6ad0ff; }
  /* 危险态叠加斜纹，不只靠颜色传达 */
  .error-notification .description .capacity-alert-track i.is-danger { background: repeating-linear-gradient(135deg, #e5484d, #e5484d 5px, #f2686c 5px, #f2686c 10px); }
  .error-notification .description .capacity-alert-track i.is-warning { background: #f5a623; }
  .error-notification .description .capacity-alert-track i.is-normal { background: #35a4e8; }

  .error-notification .description .capacity-alert-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .error-notification .description .capacity-alert-cell {
    position: relative;
    min-width: 0;
    padding: 7px 10px 7px 12px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, .09);
    border-radius: 6px;
    background: rgba(255, 255, 255, .04);
  }

  /* 左侧色条按指标语义着色 */
  .error-notification .description .capacity-alert-cell::before {
    content: '';
    position: absolute;
    top: 7px;
    bottom: 7px;
    left: 0;
    width: 2px;
    border-radius: 1px;
    background: rgba(255, 255, 255, .28);
  }

  .error-notification .description .capacity-alert-cell span {
    display: block;
    overflow: hidden;
    color: #93aec4;
    font-size: 11px;
    font-weight: 400;
    letter-spacing: .4px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .error-notification .description .capacity-alert-cell strong {
    display: block;
    margin-top: 3px;
    overflow: hidden;
    color: #eaf6ff;
    font-size: 14px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .error-notification .description .capacity-alert-cell.tone-primary::before { background: #35a4e8; }
  .error-notification .description .capacity-alert-cell.tone-primary strong { color: #6ad0ff; }
  .error-notification .description .capacity-alert-cell.tone-success::before { background: #34b782; }
  .error-notification .description .capacity-alert-cell.tone-success strong { color: #5fd6a4; }
  .error-notification .description .capacity-alert-cell.tone-warning::before { background: #d98a1f; }
  .error-notification .description .capacity-alert-cell.tone-warning strong { color: #ffb454; }
  .error-notification .description .capacity-alert-cell.tone-info::before { background: #6d81d6; }
  .error-notification .description .capacity-alert-cell.tone-info strong { color: #a9bcff; }
  .error-notification .description .capacity-alert-cell.tone-muted strong { color: #b9cbdb; }

  /* 紧急通知动作标识：与历史表格保持同一套语义 */
  .error-notification .description .emergency-action-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 24px;
    margin-left: 4px;
    padding: 2px 10px 2px 5px;
    border: 1px solid transparent;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.2px;
    vertical-align: middle;
    white-space: nowrap;
  }

  .error-notification .description .emergency-action-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 800;
    line-height: 1;
  }

  .error-notification .description .emergency-action-stop {
    color: #ff8b8b;
    background: linear-gradient(135deg, rgba(255, 64, 64, 0.24), rgba(183, 28, 28, 0.16));
    border-color: rgba(255, 99, 99, 0.72);
    box-shadow: 0 0 12px rgba(255, 64, 64, 0.24);
  }

  .error-notification .description .emergency-action-stop .emergency-action-icon {
    color: #fff;
    background: #ef5350;
    box-shadow: 0 0 8px rgba(255, 82, 82, 0.75);
  }

  .error-notification .description .emergency-action-recover {
    color: #76f2b2;
    background: linear-gradient(135deg, rgba(0, 200, 130, 0.22), rgba(0, 120, 90, 0.14));
    border-color: rgba(57, 220, 145, 0.7);
    box-shadow: 0 0 12px rgba(0, 220, 140, 0.2);
  }

  .error-notification .description .emergency-action-recover .emergency-action-icon {
    color: #003d2c;
    background: #5af0a5;
    box-shadow: 0 0 8px rgba(90, 240, 165, 0.65);
  }

  .error-notification .description .emergency-action-unknown {
    color: #8edcff;
    background: rgba(0, 180, 255, 0.14);
    border-color: rgba(0, 200, 255, 0.5);
  }

  .error-notification .description .emergency-action-unknown .emergency-action-icon {
    color: #002d40;
    background: #72ddff;
  }

  .error-notification .description .emergency-reason-text {
    color: #9bdcff;
    font-weight: 500;
    letter-spacing: 0.15px;
    text-shadow: 0 0 8px rgba(95, 207, 255, 0.28);
  }

  /* 紧急通知详情：将标题、标签和值整理成信息卡片 */
  .error-notification.notification-emergency {
    width: 440px;
    max-width: calc(100vw - 32px);
    box-sizing: border-box;
    padding: 18px 20px 20px;
  }

  .error-notification.notification-emergency .notification-content {
    gap: 14px;
    margin-bottom: 4px;
  }

  .error-notification.notification-emergency .message-wrapper {
    padding-right: 22px;
  }

  .error-notification.notification-emergency .title {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    color: #f3fcff;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 1px;
    text-shadow: 0 0 12px rgba(181, 239, 255, 0.42);
  }

  .error-notification.notification-emergency .title::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 19px;
    border-radius: 3px;
    background: linear-gradient(180deg, #ff7676, #ffad66);
    box-shadow: 0 0 10px rgba(255, 99, 99, 0.72);
  }

  .error-notification.notification-emergency .title::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    background: linear-gradient(90deg, rgba(255, 103, 103, 0.8), rgba(88, 214, 255, 0.45), transparent);
  }

  .error-notification.notification-emergency .description {
    display: flex;
    flex-direction: column;
    gap: 5px;
    color: #e9f9ff;
    line-height: 1.35;
  }

  .error-notification.notification-emergency .emergency-detail-row {
    display: flex;
    align-items: center;
    min-height: 27px;
    padding: 3px 8px;
    border: 1px solid rgba(80, 193, 231, 0.14);
    border-radius: 6px;
    background: linear-gradient(100deg, rgba(18, 80, 112, 0.3), rgba(3, 35, 61, 0.22));
    box-shadow: inset 0 1px 0 rgba(183, 239, 255, 0.04);
  }

  .error-notification.notification-emergency .emergency-detail-row:nth-child(even) {
    background: linear-gradient(100deg, rgba(21, 96, 126, 0.24), rgba(3, 35, 61, 0.16));
  }

  .error-notification.notification-emergency .emergency-detail-label {
    position: relative;
    flex: 0 0 76px;
    padding-left: 9px;
    color: rgba(186, 225, 237, 0.72);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.35px;
    white-space: nowrap;
  }

  .error-notification.notification-emergency .emergency-detail-label::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 3px;
    height: 12px;
    border-radius: 2px;
    background: #4ec9ec;
    box-shadow: 0 0 7px rgba(78, 201, 236, 0.72);
    transform: translateY(-50%);
  }

  .error-notification.notification-emergency .emergency-detail-value {
    min-width: 0;
    overflow: hidden;
    color: #eefaff;
    font-size: 13px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .error-notification.notification-emergency .emergency-value-code {
    color: #a8e8ff;
    font-family: Consolas, 'Courier New', monospace;
    letter-spacing: 0.4px;
  }

  .error-notification.notification-emergency .emergency-value-time {
    color: #c4e8f2;
    font-variant-numeric: tabular-nums;
  }

  .error-notification.notification-emergency .emergency-row-robot {
    border-color: rgba(78, 201, 236, 0.34);
    background: linear-gradient(100deg, rgba(19, 101, 139, 0.34), rgba(3, 39, 65, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-robot .emergency-detail-label {
    color: #9bdff3;
  }

  .error-notification.notification-emergency .emergency-row-robot .emergency-detail-label::before {
    background: #4ec9ec;
    box-shadow: 0 0 7px rgba(78, 201, 236, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-robot .emergency-value-robot {
    color: #d2f5ff;
  }

  .error-notification.notification-emergency .emergency-row-code {
    border-color: rgba(171, 139, 255, 0.34);
    background: linear-gradient(100deg, rgba(73, 52, 131, 0.3), rgba(25, 28, 71, 0.24));
  }

  .error-notification.notification-emergency .emergency-row-code .emergency-detail-label {
    color: #c7b7ff;
  }

  .error-notification.notification-emergency .emergency-row-code .emergency-detail-label::before {
    background: #ab8bff;
    box-shadow: 0 0 7px rgba(171, 139, 255, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-code .emergency-value-code {
    color: #e0d6ff;
  }

  .error-notification.notification-emergency .emergency-row-action {
    border-color: rgba(255, 112, 112, 0.34);
    background: linear-gradient(100deg, rgba(123, 48, 62, 0.28), rgba(54, 28, 49, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-action .emergency-detail-label {
    color: #ffb0a8;
  }

  .error-notification.notification-emergency .emergency-row-action .emergency-detail-label::before {
    background: #ff7373;
    box-shadow: 0 0 7px rgba(255, 115, 115, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-alert {
    border-color: rgba(255, 112, 112, 0.34);
    background: linear-gradient(100deg, rgba(123, 48, 62, 0.28), rgba(54, 28, 49, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-alert .emergency-detail-label {
    color: #ffb0a8;
  }

  .error-notification.notification-emergency .emergency-row-alert .emergency-detail-label::before {
    background: #ff7373;
    box-shadow: 0 0 7px rgba(255, 115, 115, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-reason {
    border-color: rgba(255, 193, 93, 0.36);
    background: linear-gradient(100deg, rgba(123, 87, 34, 0.28), rgba(54, 39, 27, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-reason .emergency-detail-label {
    color: #ffd58b;
  }

  .error-notification.notification-emergency .emergency-row-reason .emergency-detail-label::before {
    background: #ffc15d;
    box-shadow: 0 0 7px rgba(255, 193, 93, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-reason .emergency-reason-text {
    color: #ffe0a4;
    text-shadow: 0 0 8px rgba(255, 193, 93, 0.28);
  }

  .error-notification.notification-emergency .emergency-row-time {
    border-color: rgba(105, 218, 188, 0.32);
    background: linear-gradient(100deg, rgba(24, 104, 96, 0.28), rgba(19, 55, 65, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-time .emergency-detail-label {
    color: #9ee3d2;
  }

  .error-notification.notification-emergency .emergency-row-time .emergency-detail-label::before {
    background: #69dabc;
    box-shadow: 0 0 7px rgba(105, 218, 188, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-time .emergency-value-time {
    color: #c6f0e5;
  }

  .error-notification.notification-emergency .emergency-detail-empty {
    color: rgba(210, 239, 247, 0.42);
  }
</style>
